import { apiClient } from './client'

export type AgentRole =
  | 'PaidHikingCoach'
  | 'FreeHikingCoach'
  | 'SubscriptionSales'
  | 'PaidCustomerSupport'
  | 'FreeCustomerSupport'

export const AGENT_ROLES: AgentRole[] = [
  'PaidHikingCoach',
  'FreeHikingCoach',
  'SubscriptionSales',
  'PaidCustomerSupport',
  'FreeCustomerSupport'
]

export const AGENT_ROLE_LABELS: Record<AgentRole, string> = {
  PaidHikingCoach: 'Paid Hiking Coach',
  FreeHikingCoach: 'Free Hiking Coach',
  SubscriptionSales: 'Subscription Sales',
  PaidCustomerSupport: 'Paid Customer Support',
  FreeCustomerSupport: 'Free Customer Support'
}

// Prompts and models are baked into backend code (SystemPromptCatalog.cs) so all
// environments and evals run identical configurations. This API is read-only.
export type SystemPrompt = {
  id: string
  name: string
  description: string
  promptContent: string
  model: string
  role: AgentRole | null
  isActive: boolean
  createdAt: string
  updatedAt: string
}

export async function getSystemPrompts() {
  const { data } = await apiClient.get<SystemPrompt[]>('/api/admin/system-prompts')
  return data
}
